/* eslint-disable max-classes-per-file */
import { connect } from "react-redux";

import { BaseTable } from "merchant/features/analytics/common/transactions/transactionsTable";

import { FETCH_TRANSACTIONS } from "common/actions/analytics";
import { txn_search } from "common/config/api";
import { request } from "common/components/request";

const mapStateToProps = (state) => ({
    qualifiers: state.common.qualifiersStr,
    table_configs: state.components.table_configs.transactions,
    haveAutomaticDownload: state.common.user.superuser
});

export const SearchTransactions = connect(mapStateToProps)(class extends BaseTable {
    componentDidUpdate(prevProps) {
        if (this.props.qualifiers !== prevProps.qualifiers && this.props.qualifiers !== "") {
            this.fetchData({ q: this.props.qualifiers, page: 1 });
        }
        this.adjustDatatable();
    }

    fetchData = (options = {}) => {
        this.cleanPromises();
        this.setState({ isLoading: true });
        const promise = FETCH_TRANSACTIONS({
            url: this.getEndpointUrl(this.props.section),
            limit: 100,
            page: this.state.page,
            q: this.props.qualifiers,
            ...options
        }).then(
            ({ results, ...rest }) => {
                this.setState({
                    isLoading: false, data: results, ...rest
                });
                return results;
            }
        ).catch(this.catchFetchErrors);

        this.promises.push(promise);
    };
});

export const SearchTransactionsById = connect(mapStateToProps)(class extends BaseTable {
    componentDidUpdate(prevProps) {
        if (this.props.qualifiers !== prevProps.qualifiers && this.props.qualifiers !== "") {
            this.fetchData({ q: this.props.qualifiers, page: 1 });
        }
        this.adjustDatatable();
    }

    fetchData = (options = {}) => {
        this.cleanPromises();
        
        if (!this.props.pz_transaction_ref) {
            this.setState({
                isLoading: false, data: [], hasError: true, error: { error: new Error("Missing pazien transaction reference"), capture: true }
            });
            return;
        }

        this.setState({ isLoading: true });

        const promise = request(txn_search[this.props.section], {
            data: {
                id: this.props.pz_transaction_ref
            }
        }).then(
            (data) => {
                this.setState({
                    isLoading: false,
                    data,
                    count: data.length
                });
                return data;
            }
        ).catch(this.catchFetchErrors);

        this.promises.push(promise);
    };
});
